import { TtNavbar } from './TtNavbar.js';

if (typeof window !== 'undefined') {
  if (!window.customElements.get('tt-navbar')) {
    window.customElements.define('tt-navbar', TtNavbar);
  }
}
